<template>
  <currency-input
    class="form-control input__currency"
    :auto-decimal-mode="autoDecimalMode"
    :distraction-free="distractionFree"
    :currency="currency"
    :locale="locale"
    :precision="precision"
    :value-as-integer="valueAsInteger"
    v-model.number="data"
    @input="emit"
  />
</template>

<script>
// import CurrencyInput from "vue-currency-input";

export default {
  name: "BaseCurrency",
  // components: {
  //   CurrencyInput
  // },
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    },
    autoDecimalMode: {
      type: Boolean,
      default: true
    },
    distractionFree: {
      type: [Boolean, String],
      default: false
    },
    currency: {
      type: String,
      default: "PLN"
    },
    locale: {
      type: String,
      default: "pl-PL"
    },
    precision: {
      type: Number,
      default: 2
    },
    valueAsInteger: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: ""
    };
  },
  created() {
    this.data = this.value;
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.data = newValue;
      }
    }
  },
  methods: {
    emit() {
      this.$emit("input", this.data);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";

.input__currency {
  border: none;
  background: none;
  width: 125px;
  text-align: right;

  &.form-control:disabled,
  &.form-control[readonly] {
    background: none;
    color: $col-gray-dark;
  }
}
</style>
